function caseWorkspacePath(screenId: string, caseId: string) {
  return `/workspace/${screenId}?caseId=${encodeURIComponent(caseId)}`;
}

/**
 * Legacy Calls URLs remain resolvable so old links and audit records do not
 * strand staff. They are not standalone Central workflows. Inquiries resolve
 * to the standalone inquiry queue (restored 2026-09-04, decision D3).
 */
export function resolveCentralLegacyWorkspaceRedirect(
  screenId: string | undefined,
  caseId: string,
) {
  if (screenId === "calls") {
    return caseId
      ? caseWorkspacePath("call-tracking", caseId)
      : "/workspace/case-list";
  }

  if (screenId === "call-tracking" && !caseId) {
    return "/workspace/case-list";
  }

  // The family follow-up portal is case-scoped: its staff panel lives on the
  // case overview (WP-2.2). Bare URLs land back on the case list gracefully.
  if (screenId === "family-follow-up-portal") {
    return caseId
      ? caseWorkspacePath("case-overview", caseId)
      : "/workspace/case-list";
  }

  return null;
}
